import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-score',
  templateUrl: './consulta-score.component.html',
  styleUrls: ['./consulta-score.component.scss']
})
export class ConsultaScoreComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
